module.exports = __webpack_public_path__ + "img/rf1.241a04b5.png";